var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.45932 7.68457H26.756C28.0019 7.68457 29.0121 8.69479 29.0121 9.94068V24.5992C29.0121 25.8451 28.0019 26.8539 26.7574 26.8539H6.45932C5.21481 26.8553 4.20459 25.8451 4.20459 24.5992V9.94068C4.20459 8.69479 5.21481 7.68457 6.45932 7.68457Z",
    stroke: "#828282",
    strokeWidth: 2.06729,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36865 9.10413L14.9725 16.6883C15.9303 17.3733 17.2176 17.3747 18.1768 16.6911L28.8413 9.08484",
    stroke: "#828282",
    strokeWidth: 2.06729,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.44cdc9525d6c0c7ca7f23d045e20bb69.svg";
export { ForwardRef as ReactComponent };